/** Paridade com thalamus-acesso-mobile/src/config/visitanteCheckinObrigatorio.ts */

import { temDocumentoVisitante } from "@/config/visitante-documentos";

export function visitanteNaLinhaDoCheckin(lista, visitanteIndex) {
  if (!Array.isArray(lista) || lista.length === 0) return null;
  const i =
    Number.isFinite(visitanteIndex) && visitanteIndex >= 0 && visitanteIndex < lista.length
      ? visitanteIndex
      : 0;
  return lista[i] ?? lista[0] ?? null;
}

/** Campos obrigatórios só na hora do check-in (cadastro/solicitação podem ficar incompletos até lá). */
export function pendenciasCadastroVisitanteParaCheckin(v) {
  if (!v) return ["Dados do visitante"];
  const f = [];
  if (!String(v.nomeCompleto ?? v.nome_completo ?? "").trim()) f.push("Nome completo");
  if (!temDocumentoVisitante(v)) f.push("CPF ou RG");
  return f;
}

export function dadosCadastraisVisitanteOkParaCheckin(v) {
  return pendenciasCadastroVisitanteParaCheckin(v).length === 0;
}
